import { render, staticRenderFns } from "./ResultImportModal.vue?vue&type=template&id=0a20391a&scoped=true&lang=html&"
import script from "./ResultImportModal.vue?vue&type=script&lang=js&"
export * from "./ResultImportModal.vue?vue&type=script&lang=js&"
import style0 from "./ResultImportModal.vue?vue&type=style&index=0&id=0a20391a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a20391a",
  null
  
)

export default component.exports